import KysTedarikciPerformansListesi from './KysTedarikciPerformansListesi.vue'
import KysTedarikciPerformansEkle from './KysTedarikciPerformansEkle.vue'

export default [
  {
    path: '/kys-tedarikci-performans',
    name: 'kys-tedarikci-performans',
    component: KysTedarikciPerformansListesi,
    meta: {
      public: false,
      title: 'EYS Tedarikçi Performans Değerlendirme',
      yetki: { k: [1191002] },
    },
  },
  {
    path: '/kys-tedarikci-performans/ekle',
    name: 'kys-tedarikci-performans-ekle',
    component: KysTedarikciPerformansEkle,
    meta: {
      public: false,
      title: 'Tedarikçi Performans Ekle',
      yetki: { k: [1191003] },
    },
  },
  {
    path: '/kys-tedarikci-performans/duzelt/:uuid',
    name: 'kys-tedarikci-performans-duzelt',
    component: KysTedarikciPerformansEkle,
    meta: {
      public: false,
      title: 'Tedarikçi Performans Düzelt',
      yetki: { k: [1191004] },
    },
  },
]
